// @ts-nocheck

/* ---------------- lobby invite URLs (/lobby/ABCD) ---------------- */
export function parseLobbyInviteCode() {
  const parts = location.pathname.replace(/\/+$/, "").split("/");
  if (parts.length === 3 && parts[1].toLowerCase() === "lobby") {
    const code = parts[2].trim().toUpperCase();
    if (/^[A-Z0-9]{4}$/.test(code)) return code;
  }
  return null;
}

export function lobbyInviteURL(code) {
  return `${location.origin}/lobby/${(code || "").trim().toUpperCase()}`;
}

export async function copyInviteLink(code, btn) {
  const link = lobbyInviteURL(code);
  try {
    await navigator.clipboard.writeText(link);
  } catch {
    const ta = document.createElement("textarea");
    ta.value = link;
    ta.style.position = "fixed";
    ta.style.opacity = "0";
    document.body.appendChild(ta);
    ta.select();
    try { document.execCommand("copy"); } catch {}
    document.body.removeChild(ta);
  }
  if (!btn) return;
  btn.textContent = "Copied!";
  btn.classList.add("copied");
  clearTimeout(btn._copyT);
  btn._copyT = setTimeout(() => {
    btn.textContent = "Copy link";
    btn.classList.remove("copied");
  }, 1400);
}
